import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("currentUser"));
        if (saved) setUser(saved);
        setLoading(false);
    }, []);

    function login(userData) {
        setUser(userData);
        localStorage.setItem("currentUser", JSON.stringify(userData));
    }

    function logout() {
        setUser(null);
        localStorage.removeItem("currentUser");
    }

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}